// extracted by mini-css-extract-plugin
export default {"toast":"permanent-toast-module__toast___a8t3w","toast-children":"permanent-toast-module__toast-children___S3Y5D"};